import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { FlatButton, Dialog, List, ListItem } from 'material-ui';
import { red500, green500, orange500 } from 'material-ui/styles/colors';
import ActionInfo from 'material-ui/svg-icons/action/info';
import Checkmark from 'material-ui/svg-icons/action/check-circle';
import { UPDATE, showNotification as showNotificationAction, translate } from 'admin-on-rest';
import { push as pushAction } from 'react-router-redux';
import { get, compact } from 'lodash';

import { getTranslationByLocale } from '../../utils/TranslationUtils';
import { kunal } from '../../client';
import kunalClient from '../../client/kunalClient';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';
const restClient = kunalClient(API_BASE_URL, kunal);
const urlRegex = new RegExp('(https|http)?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)');

// eslint-disable-next-line no-shadow
const ConfirmDialog = ({ open, record, toggle, onSubmit, translate, locale }) => {
  const attributes = [
    { key: 'title', msg: 'noTitleProvided', fn: (value) => value.findIndex((val) => val && !!val.content) !== -1 },
    { key: 'subtitle', msg: 'noSubTitleProvided', fn: (value) => value.findIndex((val) => val && !!val.content) !== -1, color: orange500 },
    { key: 'tableBooking.href',
      msg: 'invalidTableBookingLink',
      fn: (link) => {
        if (link.indexOf('&') !== -1) { // has preferredPlace
          const values = link.substring(link.indexOf('=') + 1, link.indexOf('&')).split(',');
          return compact(values).length > 0;
        }
        const values = link.substring(link.indexOf('places=') + 'places='.length).split(',');
        return compact(values).length > 0;
      } },
    { key: 'supportedPSPs', msg: 'noPaymentMethods', fn: (value) => value && value.length },
    { key: 'extData.externalId', msg: 'syncDisabled', fn: (value) => !!value, color: orange500 },
    { key: 'loc.coordinates', msg: 'noCoordinatesProvided', fn: (value) => value[0] && value[1] },
    { key: 'products', msg: 'noProductsChosen', fn: (value) => value && value.length },
    { key: 'visitationAddress.addressLine1', msg: 'noAddressProvided', fn: (value) => !!value },
    { key: 'visitationAddress.city', msg: 'noCityProvided', fn: (value) => !!value },
    { key: 'visitationAddress.zipCode', msg: 'noZipCodeProvided', fn: (value) => !!value },
    { key: 'visitationAddress.country', msg: 'noCountryProvided', fn: (value) => !!value },
    { key: 'urls.jobApplication', msg: 'invalidUrl', fn: (value) => !value || urlRegex.test(value) },
  ];

  return (
    <Dialog
      contentStyle={{ width: '400px' }}
      autoScrollBodyContent
      open={open}
      actions={[
        <FlatButton label="Cancel" onClick={toggle} />,
        <FlatButton label="Confirm" onClick={onSubmit} />,
      ]}
    >
      {record.appIdWhitelist.length &&
        <div>
          <h4>{translate('unpublishConfirm')} {getTranslationByLocale(record.title, locale)}?</h4>
        </div>
      }
      <List>
        {attributes.map((attribute) => {
          const valid = attribute.fn(get(record, attribute.key));
          return (
            <ListItem
              primaryText={<div style={valid ? { color: green500 } : { color: attribute.color || red500 }}>{translate(`resources.venues.fields.${attribute.key}`)}</div>}
              rightIcon={valid ? <Checkmark style={{ top: '1px' }} color={green500} /> : <ActionInfo color={attribute.color || red500} />}
              open
              secondaryText={valid ? null : <div style={{ color: attribute.color || red500 }}>{translate(`publishMessages.${attribute.msg}`)}</div>}
            />
          );
        })}
      </List>
    </Dialog>
  );
};

class VenuePublishButton extends Component {
  constructor() {
    super();
    this.state = {
      confirmOpen: false,
    };
  }

  handleClick = (action) => {
    const { push, record, showNotification } = this.props;
    const updatedRecord = { ...record, updatedAt: new Date() };

    if (action === 'publish') {
      updatedRecord.appIdWhitelist = ['pinchos'];
    } else {
      updatedRecord.appIdWhitelist = [];
    }

    restClient(UPDATE, 'venues', { id: record.name, data: updatedRecord })
      .then(() => {
        showNotification(`Venue ${action}ed`);
        push('/venues');
      })
      .catch((e) => {
        console.error(e);
        showNotification(`Error: venue not ${action}`, 'warning');
      });
  }

  openConfirm = () => this.setState({ confirmOpen: !this.state.confirmOpen });

  render() {
    // eslint-disable-next-line no-shadow
    const { record: { appIdWhitelist }, translate } = this.props;
    // return <FlatButton label={appIdWhitelist.length ? 'unpublish' : 'publish'} onClick={() => this.handleClick(appIdWhitelist.length ? 'unpublish' : 'publish')} />;
    return (
      <div>
        <FlatButton label={appIdWhitelist.length ? translate('unpublish') : translate('publish')} onClick={() => this.openConfirm()} />
        <ConfirmDialog
          open={this.state.confirmOpen}
          toggle={() => this.openConfirm()}
          onSubmit={() => this.handleClick(appIdWhitelist.length ? 'unpublish' : 'publish')}
          {...this.props}
        />
      </div>
    );
  }
}
VenuePublishButton.propTypes = {
  push: PropTypes.func,
  record: PropTypes.object,
  showNotification: PropTypes.func,
};

const selector = getFormValues('record-form');

export default connect(
  (state) => ({ record: selector(state) }),
  {
    showNotification: showNotificationAction,
    push: pushAction,
  }
)(translate(VenuePublishButton));
